module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"gave_mileage_message":"<b>{mileage_amount}円分付与されました｜</b>","hidden_by_admin_message":"このレビューは登録基準を満たしていないため、表示されていません。","hidden_by_system_message":"このレビューは登録基準を満たしていないため、表示されていません。","hidden_by_before_confirmation_message":"投稿は現在審査中です。確認後に公開されます。","review_edit_or_delete_info":"レビューの修正や削除をご希望の場合は、カスタマーサービスまでお問い合わせください。"}}')
  delete Component.options._Ctor
}
